import React, { useEffect } from "react";
import { Link } from "react-router-dom";

const AboutUs = () => {
  useEffect(() => {
    if (window.jQuery) {
      const $ = window.jQuery;

      // Initialize testimonials carousel
      $(".testimonials-carousel_1").owlCarousel({
        loop: true,
        margin: 30,
        nav: false,
        dots: false,
        autoplay: true,
        autoplayTimeout: 6000,
        items: 1,
        responsive: {
          0: { items: 1 },
          600: { items: 1 },
          768: { items: 1 },
          992: { items: 1 },
          1200: { items: 1 }
        }
      });

      // Initialize wow animations
      if (window.WOW) {
        new window.WOW().init();
      }

      // Fact Counter
      if ($('.count-box').length) {
        $('.count-box').appear(function () {
          var $t = $(this),
            n = $t.find(".count-text").attr("data-stop"),
            r = parseInt($t.find(".count-text").attr("data-speed"), 10);

          if (!$t.hasClass("counted")) {
            $t.addClass("counted");
            $({
              countNum: $t.find(".count-text").text()
            }).animate({
              countNum: n
            }, {
              duration: r,
              easing: "linear",
              step: function () {
                $t.find(".count-text").text(Math.floor(this.countNum));
              },
              complete: function () {
                $t.find(".count-text").text(this.countNum);
              }
            });
          }
        }, {
          accY: 0
        });
      }

      // Accordion Box
      if ($('.accordion-box').length) {
        $('.accordion-box').on('click', '.acc-btn', function () {
          var outerBox = $(this).parents('.accordion-box');
          var target = $(this).parents('.accordion');

          if ($(this).hasClass('active') !== true) {
            $(outerBox).find('.accordion .acc-btn').removeClass('active');
          }

          if ($(this).next('.acc-content').is(':visible')) {
            return false;
          } else {
            $(this).addClass('active');
            $(outerBox).children('.accordion').removeClass('active-block');
            $(outerBox).find('.accordion').children('.acc-content').slideUp(300);
            target.addClass('active-block');
            $(this).next('.acc-content').slideDown(300);
          }
        });
      }
    }
  }, []);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  return (
    <>
      <div className="boxed_wrapper ltr">


        {/*Start breadcrumb area paroller*/}
        <section className="breadcrumb-area">
          <div className="breadcrumb-area-bg" style={{ backgroundImage: 'url(/assets/images/breadcrumb/breadcrumb-1.jpg)' }}>
          </div>
          <div className="container">
            <div className="row">
              <div className="col-xl-12">
                <div className="inner-content">
                  <div className="title">
                    <h2>ABOUT BUDPLAN</h2>
                  </div>
                  <div className="breadcrumb-menu">
                    <ul>
                      <li><Link to="/">Home</Link></li>
                      <li><i className="fa fa-angle-right" aria-hidden="true" /></li>
                      <li className="active">About Us</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/*End breadcrumb area*/}



        {/*Start About Style3 Area*/}
        <section className="about-style3-area about-page">
          <div className="shape3 wow slideInLeft" data-wow-delay="500ms" data-wow-duration="7000ms">
            <img className="float-bob-y" src="/assets/images/shape/about-style3-shape-3.png" alt="" />
          </div>
          <div className="container">
            <div className="row">
              {/*Start About Style3 Content Box*/}
              <div className="col-xl-6">
                <div className="about-style3-content-box">
                  <div className="sec-title">
                    <div className="sub-title">
                      <p>About Bud Plan Consultancy</p>
                    </div>
                    <h2>Smart Construction Planning
                      for Modern Developments
                    </h2>
                  </div>
                  <div className="text1">
                    <p className="about-ustxt">
                      Bud Plan Consultancy provides professional services in architecture, building planning, layout design, and government
                      scheme approvals. We assist individuals, developers, and property owners in transforming their ideas into well-planned
                      and legally compliant developments.
                    </p>
                  </div>
                  <div className="text2">
                    <p>
                      Our services include architectural design, building construction consultancy, layout planning, and guidance for government
                      schemes such as LRS, BPS, and Transferable Development Rights (TDR). With a commitment to quality, efficiency, and
                      regulatory compliance, Bud Plan Consultancy helps clients achieve sustainable and well-structured development solutions.
                    </p>
                  </div>
                  <ul>
                    <li>
                      <div className="single-counting-box">
                        <div className="count-outer count-box">
                          <span className="count-text" data-speed={3000} data-stop={35}>0</span>
                          <span className="flaticon-plus plus" />
                        </div>
                        <div className="title">
                          <h6>Experience<br /> Members</h6>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className="single-counting-box style2">
                        <div className="count-outer count-box">
                          <span className="count-text" data-speed={3000} data-stop={100}>0</span>
                          {/* <span className="k">+</span> */}
                          <span className="flaticon-plus plus" />
                        </div>
                        <div className="title">
                          <h6>Satisfied<br /> Clients</h6>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              {/*End About Style3 Content Box*/}
              {/*Start About Style3 Img Box*/}
              <div className="col-xl-6">
                <div className="about-style3-img-box about-style3-img-box--about-page">
                  <div className="shape1">
                    <img className="rotate-me" src="/assets/images/shape/about-style3-shape-1.png" alt="" />
                  </div>
                  <div className="shape2">
                    <img className="rotate-me-2" src="/assets/images/shape/about-style3-shape-1.png" alt="" />
                  </div>
                  <div className="main-image">
                    <div className="shape-bg zoom-fade" />
                    <div className="inner">
                      <img src="/assets/images/about/about-style3-img1.jpg" alt="" />
                    </div>
                  </div>
                  <div className="about-image-2 wow zoomIn paroller" data-wow-delay="100ms" data-wow-duration="3500ms">
                    <img src="/assets/images/about/about-style3-img2.jpg" alt="" />
                  </div>
                </div>
              </div>
              {/*End About Style3 Img Box*/}
            </div>
          </div>
        </section>
        {/*End About Style3 Area*/}
        {/*Start Working process area */}
        <section className="working-process-area">
          <div className="shape1 wow slideInUp" data-wow-delay="100ms" data-wow-duration="5000ms" style={{ backgroundImage: 'url(/assets/images/shape/working-process-shape-1.png)' }} />
          <div className="shape2 wow slideInLeft" data-wow-delay="100ms" data-wow-duration="3500ms">
            <img className="float-bob-y" src="/assets/images/shape/working-process-shape-2.png" alt="" />
          </div>
          <div className="shape3 wow slideInDown" data-wow-delay="100ms" data-wow-duration="4500ms">
            <img className="float-bob-x" src="/assets/images/shape/working-process-shape-3.png" alt="" />
          </div>
          <div className="shape4 wow slideInRight" data-wow-delay="100ms" data-wow-duration="3500ms">
            <img className="zoom-fade" src="/assets/images/shape/working-process-shape-4.png" alt="" />
          </div>
          <div className="container">
            <div className="sec-title text-center">
              <div className="sub-title">
                <p>Working Plan</p>
              </div>
              <h2>BUDPLAN Working Process</h2>
            </div>
            <div className="row">
              <div className="col-xl-12">
                <ul className="working-process-box">
                  {/*Start Working process Single*/}
                  <li className="single-working-process wow fadeInUp" data-wow-delay="00ms" data-wow-duration="1500ms">
                    <div className="arrow-box"><img src="/assets/images/shape/arrow.png" alt="" /></div>
                    <div className="img-holder">
                      <img src="/assets/images/resources/working-process-1.png" alt="" />
                      <div className="count" />
                    </div>
                    <div className="text-holder">
                      <h3>Consultation & Requirement Review</h3>
                      <p>Share your project details with our team. We understand your requirements,
                        site conditions, and compliance needs.
                      </p>
                    </div>
                  </li>
                  {/*End Working process Single*/}
                  {/*Start Working process Single*/}
                  <li className="single-working-process wow fadeInUp" data-wow-delay="100ms" data-wow-duration="1500ms">
                    <div className="arrow-box"><img src="/assets/images/shape/arrow-2.png" alt="" /></div>
                    <div className="img-holder">
                      <img src="/assets/images/resources/working-process-2.png" alt="" />
                      <div className="count" />
                    </div>
                    <div className="text-holder">
                      <h3>Planning & Approvals</h3>
                      <p>Our experts prepare designs, drawings, and handle approvals, layouts,
                        TDR services, and documentation.
                      </p>
                    </div>
                  </li>
                  {/*End Working process Single*/}
                  {/*Start Working process Single*/}
                  <li className="single-working-process wow fadeInUp" data-wow-delay="200ms" data-wow-duration="1500ms">
                    <div className="img-holder">
                      <img src="/assets/images/resources/working-process-3.png" alt="" />
                      <div className="count" />
                    </div>
                    <div className="text-holder">
                      <h3>Execution Support & Completion</h3>
                      <p>We coordinate with stakeholders and support execution to ensure smooth,
                        timely, and compliant project completion.
                      </p>
                    </div>
                  </li>
                  {/*End Working process Single*/}
                </ul>
              </div>
            </div>
          </div>
        </section>
        {/*End Working process area */}
        {/*Start Faq Style1 Area*/}
        <section className="faq-style1-area pdtop150">
          <div className="container">
            <div className="row">
              <div className="col-xl-6">
                <div className="faq-style1__content">
                  <div className="sec-title">
                    <div className="sub-title">
                      <p>FREQUENT QUESTIONS</p>
                    </div>
                    <h2>Frequently Asked Questions</h2>
                  </div>
                  <div className="inner-content">
                    <div className="text">
                      <p>Find quick answers to common questions about our construction consultancy
                        services, approvals process, and project support.
                      </p>
                    </div>
                    <ul className="accordion-box">
                      <li className="accordion block active-block">
                        <div className="acc-btn active">
                          <div className="icon-outer"><i className="flaticon-plus" /></div>
                          <h3><b>Q.</b> How does BUDPLAN work?</h3>
                        </div>
                        <div className="acc-content current">
                          <p>We begin with a consultation to understand your project requirements, followed
                            by planning, approvals, and execution support until completion.
                          </p>
                        </div>
                      </li>
                      <li className="accordion block">
                        <div className="acc-btn">
                          <div className="icon-outer"><i className="flaticon-plus" /></div>
                          <h3><b>Q.</b> How does your pricing work?</h3>
                        </div>
                        <div className="acc-content">
                          <p>Our pricing depends on project scope, services required, and approval complexity.
                            We provide transparent and detailed quotations.
                          </p>
                        </div>
                      </li>
                      <li className="accordion block">
                        <div className="acc-btn">
                          <div className="icon-outer"><i className="flaticon-plus" /></div>
                          <h3><b>Q.</b> How can I take your service?</h3>
                        </div>
                        <div className="acc-content">
                          <p>You can contact us through phone, email, or our website form to schedule a
                            consultation with our experts.
                          </p>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-xl-6">
                <div className="faq-style1__image faq-style1__image--style2 clearfix">
                  <div className="shape1 wow zoomIn" data-wow-delay="100ms" data-wow-duration="2500ms">
                    <img className="rotate-me" src="/assets/images/shape/faq-shape-1.png" alt="" />
                  </div>
                  <div className="shape2 wow slideInUp" data-wow-delay="100ms" data-wow-duration="2500ms">
                    <img className="zoom-fade" src="/assets/images/shape/faq-shape-2.png" alt="" />
                  </div>
                  <div className="inner clearfix wow slideInRight" data-wow-delay="100ms" data-wow-duration="3500ms">
                    <img src="/assets/images/resources/faq-style2__image.png" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/*End Faq Style1 Area*/}
        {/*Start Testimonials Style2 area */}
        <div className="testimonials-style2-area">
          <div className="shape1 wow slideInDown" data-wow-delay="100ms" data-wow-duration="2000ms">
            <img className="float-bob-y" src="assets/images/shape/testimonials-style2-shape1.png" alt="" />
          </div>
          <div className="shape2 wow slideInRight" data-wow-delay="100ms" data-wow-duration="3000ms">
            <img className="rotate-me" src="assets/images/shape/testimonials-style2-shape2.png" alt="" />
          </div>
          <div className="shape3 wow slideInDown" data-wow-delay="500ms" data-wow-duration="5000ms">
            <img className="float-bob-x" src="assets/images/shape/testimonials-style2-shape3.png" alt="" />
          </div>
          <div className="shape4 wow slideInRight" data-wow-delay="500ms" data-wow-duration="7000ms">
            <img className="float-bob-y" src="assets/images/shape/testimonials-style2-shape4.png" alt="" />
          </div>
          <div className="auto-container">
            <div className="row">
              <div className="col-xl-6">
                <div className="testimonials-style2__image" style={{ backgroundImage: 'url(/assets/images/resources/testimonials-style2__image.jpg)' }}>
                </div>
              </div>
              <div className="col-xl-6">
                <div className="testimonials-style1__content testimonials-style1__content--style2">
                  <div className="testimonial-style-inner-content">
                    <div className="sec-title">
                      <div className="sub-title">
                        <p>TESTIMONIALS</p>
                      </div>
                      <h2>What Our Clients Say <br />
                        About BUDPLAN
                      </h2>
                    </div>
                    <div className="theme_carousel testimonials-carousel_1 owl-dot-style1 owl-theme owl-carousel" data-options="{&quot;loop&quot;: true, &quot;margin&quot;: 30, &quot;autoheight&quot;:true, &quot;lazyload&quot;:true, &quot;nav&quot;: false, &quot;dots&quot;: false, &quot;autoplay&quot;: true, &quot;autoplayTimeout&quot;: 6000, &quot;smartSpeed&quot;: 300, &quot;responsive&quot;:{ &quot;0&quot; :{ &quot;items&quot;: &quot;1&quot; }, &quot;600&quot; :{ &quot;items&quot; : &quot;1&quot; }, &quot;768&quot; :{ &quot;items&quot; : &quot;1&quot; } , &quot;992&quot;:{ &quot;items&quot; : &quot;1&quot; }, &quot;1200&quot;:{ &quot;items&quot; : &quot;1&quot; }}}">
                      {/*Start Single Testimonials Style1*/}
                      <div className="single-testimonials-style1">
                        <div className="text">
                          <p>"Working with BUDPLAN made our construction process smooth and stress-free.
                            Their planning, approvals support, and attention to compliance helped us
                            complete the project on time."
                          </p>
                        </div>
                        <div className="client-info">
                          <div className="img-box">
                            <img src="assets/images/testimonial/testimonial-v1-1.jpg" alt="" />
                          </div>
                          <div className="title-box">
                            <h3>Client Name</h3>
                            <span>Residential Project Owner</span>
                          </div>
                        </div>
                      </div>
                      {/*End Single Testimonials Style1*/}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/*End Testimonials Style2 area */}
        {/*Start Fact Counter Style2 Area*/}
        <section className="fact-counter-style2-area">
          <div className="container">
            <div className="row">
              <div className="col-xl-12">
                <div className="fact-counter_box fact-counter_box--style2">
                  <div className="pattern-bg" style={{ backgroundImage: 'url(/assets/images/pattern/thm-pattern-1.png)' }} />
                  <ul className="clearfix">
                    {/*Start Single Fact Counter*/}
                    <li className="single-fact-counter wow slideInUp" data-wow-delay="00ms" data-wow-duration="1500ms">
                      <div className="icon">
                        <span className="flaticon-complete" />
                      </div>
                      <div className="outer-box">
                        <div className="count-outer count-box d-flex">
                          <span className="count-text" data-speed={3000} data-stop={90}>0</span>
                          <span>+</span>
                        </div>
                        <div className="title">
                          <h6>Client Satisfaction</h6>
                        </div>
                      </div>
                    </li>
                    {/*End Single Fact Counter*/}
                    {/*Start Single Fact Counter*/}
                    <li className="single-fact-counter wow slideInUp" data-wow-delay="200ms" data-wow-duration="1500ms">
                      <div className="icon">
                        <span className="flaticon-like" />
                      </div>
                      <div className="outer-box">
                        <div className="count-outer count-box">
                          <span className="count-text" data-speed={3000} data-stop={216}>0</span>
                        </div>
                        <div className="title">
                          <h6>Projects Delivered</h6>
                        </div>
                      </div>
                    </li>
                    {/*End Single Fact Counter*/}
                    {/*Start Single Fact Counter*/}
                    <li className="single-fact-counter wow slideInUp" data-wow-delay="100ms" data-wow-duration="1500ms">
                      <div className="icon">
                        <span className="flaticon-sharing" />
                      </div>
                      <div className="outer-box">
                        <div className="count-outer count-box">
                          <span className="count-text" data-speed={3000} data-stop={35}>0</span>
                        </div>
                        <div className="title">
                          <h6>Expert Team</h6>
                        </div>
                      </div>
                    </li>
                    {/*End Single Fact Counter*/}
                    {/*Start Single Fact Counter*/}
                    <li className="single-fact-counter wow slideInUp" data-wow-delay="200ms" data-wow-duration="1500ms">
                      <div className="icon">
                        <span className="flaticon-medal" />
                      </div>
                      <div className="outer-box">
                        <div className="count-outer count-box d-flex">
                          <span className="count-text" data-speed={3000} data-stop={10}>0</span>
                          <span>+</span>
                        </div>
                        <div className="title">
                          <h6>Years of Experience</h6>
                        </div>
                      </div>
                    </li>
                    {/*End Single Fact Counter*/}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/*End Fact Counter Style2 Area*/}
        {/*Start Team Style1 Area*/}
        <section className="team-style1-area pdbtm60">

        </section>
        {/*End Team Style1 Area*/}
      </div>

    </>
  )
}

export default AboutUs;